import React from 'react';

const VerSer1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel}) => {
  const a250115 = autorizacUA.findIndex( autorizac => autorizac === "250115" );
  const a250120 = autorizacUA.findIndex( autorizac => autorizac === "250120" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a250115!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a250120!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerSer1
